import { PriceStatus } from '@toggle/helpers';
import styled, { css } from 'styled-components';

import { borderRadius } from '~/design-tokens/border-radius/borderRadius';

import { customScrollMinimal } from '../../custom-scroll/CustomScroll.styles';
import { TanStackTableRoot } from '../../tanstack-table/TanStackTable.styles';
import { StatusTypes } from './TableV2.types';

export const priceChangeColors = {
  default: 'var(--text-default)',
  negative: 'var(--viz-bearish)',
  positive: 'var(--viz-bullish)',
};

export const Container = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
`;

export const CellWrapper = styled.div<{
  $priceStatus: PriceStatus;
  $dataStatus?: StatusTypes<string>;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: ${({ $priceStatus }) => priceChangeColors[$priceStatus]};

  ${({ $dataStatus }) => {
    if ($dataStatus === 'Success') {
      return css`
        padding: 2px 8px;
        ${borderRadius.r1};
        color: var(--viz-bullish);
        background-color: var(--viz-bullish-soft);
      `;
    }

    if ($dataStatus === 'Failed') {
      return css`
        padding: 2px 8px;
        ${borderRadius.r1};
        color: var(--viz-bearish);
        background-color: var(--viz-bearish-soft);
      `;
    }

    return null;
  }}}
`;

export const CellInner = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: max-content;

  img {
    ${borderRadius.rFull};
    width: 20px;
    height: 20px;
    overflow: hidden;
  }
`;

export const Wrapper = styled.div<{
  $showBorder: boolean;
  $maxHeight?: number;
}>`
  overflow: auto;
  ${customScrollMinimal};
  width: 100%;
  position: relative;
  ${borderRadius.r2};
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border: ${({ $showBorder }) =>
    $showBorder ? '1px solid var(--border-soft)' : 'none'};
  border-top: none;
  ${({ $maxHeight }) =>
    $maxHeight &&
    css`
      max-height: ${$maxHeight}px;
    `}
`;

export const StyledTanStackTableRoot = styled(TanStackTableRoot)<{
  $isCustomHeader?: boolean;
}>`
  position: relative;
  ${borderRadius.r2}
  width: 100%;
  max-width: 100%;

  thead {
    width: 100%;
    table-layout: fixed;

    th {
      min-width: 116px;
    }
  }
  td {
    padding: ${({ $isCustomHeader }) =>
      !$isCustomHeader ? '12px' : '6px 12px'};
    min-width: 148px;
  }

  tbody tr {
    width: 100%;
    table-layout: fixed;

    td {
      min-width: 116px;
    }
  }
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
`;
